// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import '@/config/rem'
import '@/assets/style/common.scss'
import elementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/style/element-ui.scss'
import '@/assets/style/element-variables.scss'
import FastClick from 'fastclick'
import fetch from '@/config/fetch'
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css';

import animated from 'animate.css'
Vue.use(animated)

// import '@/icons' // icon

if ('addEventListener' in document) {
    document.addEventListener('DOMContentLoaded', function() {
        FastClick.attach(document.body);
    }, false);
}
Vue.use(elementUi);
Vue.use(Mint);
Vue.config.productionTip = false


import Vant from 'vant';//引入组件
import 'vant/lib/index.css';//引入样式






/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  Vant,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js